/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteBankAccountOrchestration
 */
export interface DeleteBankAccountOrchestration {
    /**
     * 
     * @type {number}
     * @memberof DeleteBankAccountOrchestration
     */
    bankAccountId: number;
    /**
     * 
     * @type {number}
     * @memberof DeleteBankAccountOrchestration
     */
    proposalId: number;
    /**
     * 
     * @type {number}
     * @memberof DeleteBankAccountOrchestration
     */
    premiumId?: number;
    /**
     * 
     * @type {number}
     * @memberof DeleteBankAccountOrchestration
     */
    incomeBankAccountId?: number;
}

/**
 * Check if a given object implements the DeleteBankAccountOrchestration interface.
 */
export function instanceOfDeleteBankAccountOrchestration(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "bankAccountId" in value;
    isInstance = isInstance && "proposalId" in value;

    return isInstance;
}

export function DeleteBankAccountOrchestrationFromJSON(json: any): DeleteBankAccountOrchestration {
    return DeleteBankAccountOrchestrationFromJSONTyped(json, false);
}

export function DeleteBankAccountOrchestrationFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteBankAccountOrchestration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bankAccountId': json['BankAccountId'],
        'proposalId': json['ProposalId'],
        'premiumId': !exists(json, 'PremiumId') ? undefined : json['PremiumId'],
        'incomeBankAccountId': !exists(json, 'IncomeBankAccountId') ? undefined : json['IncomeBankAccountId'],
    };
}

export function DeleteBankAccountOrchestrationToJSON(value?: DeleteBankAccountOrchestration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'BankAccountId': value.bankAccountId,
        'ProposalId': value.proposalId,
        'PremiumId': value.premiumId,
        'IncomeBankAccountId': value.incomeBankAccountId,
    };
}

